import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class DynamicTextBlock extends React.PureComponent<
  DynamicTextBlock.Props,
  DynamicTextBlock.State
> {
  public static sectionId = 'textblo';

  public render(): JSX.Element {
    const {
      title,
      titlefontsize,
      content,
      maxwidth,
      alignment,
    } = this.props.section.settings
    
    let alignmentClass = ''
    
    if (alignment) {
      switch (alignment) {
      case 'left':
        alignmentClass = 'text-left'
        break
      case 'center':
        alignmentClass = 'text-center'
        break
      case 'right':
        alignmentClass = 'text-right'
        break
      }
    }
    
    const titleSize = titlefontsize === 'Small' ? 'h3' : 'h1'
    const margins =
      maxwidth === 'Align with Footer'
        ? 'mx-1-6 sm:mx-2-4 2xl:mx-22 xl:mx-2-8'
        : 'mx-2 md:mx-auto'
    const maxWidth =
      maxwidth !== 'Full' && maxwidth !== 'Align with Footer'
        ? maxwidth
        : undefined

    return (
      <>
        <section className={'dynamic-text-block'}>
          <div
            style={{ maxWidth }}
            className={`${!maxWidth && 'max-w-container'} ${margins ||
              'mx-auto'} my-6 relative`}
          >
            {title ? (
              <div className={'w-full text-center mb-2-4'}>
                <Snippets.Heading
                  size={titleSize}
                  tag={'h2'}
                  className={'text-center text-black'}
                >
                  {title}
                </Snippets.Heading>
              </div>
            ) : null}
            <div className={'w-full text-center mb-2-4'}>
              <Snippets.RichText size={'p'} className={alignmentClass}>{content}</Snippets.RichText>
            </div>
          </div>
        </section>
      </>
    )
  }
}

export namespace DynamicTextBlock {
  export interface Options
    extends ShopifyNext.Section<{
      title: string;
      titlefontsize: 'Large' | 'Small';
      content: string;
      maxwidth: string;
      alignment: string;
    }> {}
  export interface Props extends GlobalProps {
    section: DynamicTextBlock.Options;
  }
  export interface State {}
}
